import { createContext } from "react";

export const UserContext = createContext(null);
export const UserPhoneContext = createContext(null);
export const QuestContext = createContext(null);
